import api from './base'

export default {
  getAll ({ childCompanyId, electronicDeviceId, number, dateFrom, dateTo }) {
    let url = `company/child_companies/${childCompanyId}/electronic_devices/${electronicDeviceId}/invoices?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (number) {
      url += `&invoiceNumber=${number}`
    }
    return api().get(url)
  },
  getCommunicationData ({ childCompanyId, id }) {
    return api().get(`company/child_companies/${childCompanyId}/invoices/${id}/communication_data`)
  }
}
